/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { CreditorInstitutionStation } from "./CreditorInstitutionStation";
import * as t from "io-ts";

// required attributes
const CreditorInstitutionStationListR = t.interface({
  stations: t.readonlyArray(
    CreditorInstitutionStation,
    "array of CreditorInstitutionStation"
  )
});

// optional attributes
const CreditorInstitutionStationListO = t.partial({});

export const CreditorInstitutionStationList = t.intersection(
  [CreditorInstitutionStationListR, CreditorInstitutionStationListO],
  "CreditorInstitutionStationList"
);

export type CreditorInstitutionStationList = t.TypeOf<
  typeof CreditorInstitutionStationList
>;
